import React, { Fragment } from 'react'

const TestAndPackagesListSkeleton = ({ count = 6 }) => {
  const cardCount = Array(count).fill('')

  return (
    <Fragment>
      <div role="status" className="space-y-8 animate-pulse md:space-y-1">
        {cardCount?.length > 0 &&
          cardCount.map((key, index) => {
            return (
              <div
                key={`count_${index}`}
                className="w-full p-6 bg-white-100 rounded-2xl dark:bg-gray-700"
              >
                <div className="flex items-center justify-between gap-5">
                  <div>
                    <div className="h-6 w-60 bg-gray-200 rounded-full dark:bg-gray-700 mb-4"></div>
                    <div className="h-4 w-32 bg-gray-200 rounded-full dark:bg-gray-700 "></div>
                  </div>
                  <div className="h-10 w-14 bg-gray-200 rounded-xl dark:bg-gray-700 mb-2.5"></div>
                </div>
              </div>
            )
          })}
      </div>
    </Fragment>
  )
}

export default TestAndPackagesListSkeleton
